<template>
    <div v-if="error.show" class="alert-backdrop">
        
        <v-alert
        id="errorAlert"
        color="#ffffff"
        border="top"
        border-color="error">

            <div id="alertContent">
                <v-icon icon="mdi-rocket-launch" size="x-large"></v-icon>
                <h3>{{ $t(error.title) }}</h3>
                <p>{{ $t(error.message) }}</p>
                <v-btn @click="closeAlert" variant="outlined">{{ $t('CLOSE_ALERT') }}</v-btn>
            </div>

        </v-alert>

    </div>
</template>
  
<script>
    import { mapActions, mapGetters } from "vuex";

    export default {
        name: "ErrorAlert",
        computed: {
            ...mapGetters(["error"]),
        },
        methods: {
            ...mapActions(["clearError"]),
            closeAlert() {
                this.clearError();
            }
        }
    };
</script>

<style scoped>

    .alert-backdrop {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 100;
        background-color: rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #errorAlert {
        max-width: 60%;
        box-shadow: 1px 1px 8px #ccc;
    }

    #errorAlert #alertContent {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    #errorAlert #alertContent p {
        display: block;
    }

    #errorAlert #alertContent i,
    #errorAlert #alertContent p {
        margin-bottom: 16px;
    }

    #errorAlert #alertContent h3 {
        margin-bottom: 12px;
    }

</style>